export default {
  agreement:
    'By signing up, you agree to the <0>Terms and Conditions</0> and <1>Privacy Policy</1>.',
  heading: 'Sign up',
  login: 'Already a member? <0>Sign in</0>',
  or: 'or sign up with',
  subhead: 'We will send you a verification code.',
  submit: 'Agree and continue',
};
